module.exports = __webpack_public_path__ + "media/images/beauty/main_image1@2x-6601af2a396886e4c4f70f9df5b0e188.jpg";